import { Collaborator } from 'core'

import { TrashIcon } from 'components/UI'

type Props = {
	collaborators: Collaborator[]
	isUserCollaborator: boolean
	openRemoveCollaboratorModal: (collaboratorUsername: string) => void
}

const CollaboratorsTable = ({
	collaborators,
	openRemoveCollaboratorModal,
	isUserCollaborator
}: Props) => (
	<table class='mt-10 w-full table-auto border-b border-solid border-b-black-800'>
		<thead class='h-12 bg-black-800 text-black-100'>
			<tr class='pr-2.5'>
				<th class='w-full px-4 py-2 text-left text-[0.625rem] font-semibold'>
					Email
				</th>
				<th class='min-w-28 px-4 py-2 text-left text-[0.625rem] font-semibold'>
					Type
				</th>
				<th class='min-w-28 px-4 py-2 text-left text-[0.625rem] font-semibold'>
					{' '}
				</th>
				{!isUserCollaborator && (
					<th class='min-w-16 px-4 py-2 text-left text-[0.625rem] font-semibold'>
						Actions
					</th>
				)}
			</tr>
		</thead>
		<tbody>
			{collaborators.map(collaborator => (
				<tr class='h-12 border-t border-gray-700 text-black-100'>
					<td class='px-4 py-2 text-sm'>{collaborator.userHandler}</td>
					<td class='px-4 py-2 text-sm first-letter:uppercase'>
						{collaborator.role}
					</td>
					{!isUserCollaborator && (
						<>
							<td class='px-4 py-2 text-sm text-black-200 first-letter:uppercase'>
								{collaborator.status}
							</td>
							<td class='px-4 py-2 text-sm'>
								<button
									disabled={isUserCollaborator}
									onClick={() =>
										openRemoveCollaboratorModal(collaborator.userHandler)
									}
									type='button'
								>
									<TrashIcon />
								</button>
							</td>
						</>
					)}
				</tr>
			))}
		</tbody>
	</table>
)

export { CollaboratorsTable }
